export const isValidRepositoryUrl = (url: string) => {
	return /^https:\/\/[^\s/$.?#].[^\s]*$/i.test(url);
};
